export const PropertiesCompositionLevel = 1;